import { Component, Input } from '@angular/core';
import { AGUAppModuleAccent } from '../../app-surface/app-module-definition';

/**
 * The tinted header band every AGU portal tool screen opens on — the mockup's
 * `.hero`: an uppercase module eyebrow over a 30px title and one line of lede,
 * on the module's own tint.
 *
 * It replaces `mj-page-header` on the finders rather than restyling it: the
 * mockup's band carries no icon, no date, no action row and no page-header rule,
 * and it is the page's H1 — three of the four things MJ's header exists to hold
 * are absent, so wrapping it would have meant hiding more than it kept.
 *
 * `Accent` is the module's own colour (AGUAppModuleDefinition.Accent). It is set
 * as a data attribute rather than a class so the value round-trips exactly as
 * the module declared it, and the stylesheet's cascade block is what turns it
 * into --accent/--accent-tint for everything inside.
 */
@Component({
    standalone: false,
    selector: 'agu-page-band',
    templateUrl: './page-band.component.html',
    styleUrl: './page-band.component.scss',
})
export class AGUPageBandComponent {
    /** Uppercase module word above the title ('Grants'). Omit to render none. */
    @Input() Eyebrow: string | null = null;
    @Input({ required: true }) Title!: string;
    /** One-sentence lede under the title. Omit to render none. */
    @Input() Sub: string | null = null;
    /** The module's colour; blue is the portal default. */
    @Input() Accent: AGUAppModuleAccent = 'blue';
}
